import React from 'react';
import I18n from 'i18n-js';
import moment from 'moment';
import Feedback from '../feedback';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { RCStarRating } from '@reverbdotcom/commons/src/rc/RCStarRating';

const TRUNCATION_LIMIT = 300;

export interface Props {
  feedback: Feedback;
}

export default class FeedbackItem extends React.Component<Props, null> {
  formatDate(date) {
    return moment(date).format('MMM Do, YYYY');
  }

  get displayDate() {
    return this.formatDate(this.props.feedback.created_at);
  }

  get feedbackResponse() {
    return this.props.feedback.feedback_response;
  }

  get feedbackResponseDate() {
    return this.formatDate(this.feedbackResponse.created_at);
  }

  renderReview() {
    return (
      <p className="mb-0 mt-1 size-90">
        <SanitizedRender
          truncationLimit={TRUNCATION_LIMIT}
          html={this.props.feedback.message}
          htmlTag="span"
        />
      </p>
    );
  }

  renderReviewMeta() {
    return (
      <div className="size-80 opacity-70">
        {I18n.t(
          'discovery.shop.feedback.byline',
          {
            date: this.displayDate,
            name: this.props.feedback.author_name,
          },
        )}
      </div>
    );
  }

  renderFeedbackResponse() {
    if (!this.feedbackResponse) {
      return null;
    }

    return (
      <div
        className="bd-1 bd-primary bg-offwhite bg--lighten padding-1 mt-2"
        data-feedback-response
      >
        <p className="mb-1">
          <SanitizedRender
            truncationLimit={TRUNCATION_LIMIT}
            html={this.feedbackResponse.body}
            htmlTag="span"
          />
        </p>
        <div className="size-90 opacity-70">
          {I18n.t(
            'discovery.shop.feedback.byline',
            {
              date: this.feedbackResponseDate,
              name: this.props.feedback.recipient_name,
            },
          )}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div
        className="scaling-padding-2 bg-white bd-1 bd-primary width-100"
      >
        <RCStarRating
          rating={this.props.feedback.rating / 5}
          hideTooltip
        />
        <div
          className="d-block weight-bold mt-half"
        >
          {this.props.feedback.order_title}
        </div>
        {this.renderReviewMeta()}
        {this.renderReview()}
        {this.renderFeedbackResponse()}
      </div>
    );
  }
}
